import { useContext, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Brightness2Icon from '@material-ui/icons/Brightness2'
import WbSunnyRoundedIcon from '@material-ui/icons/WbSunnyRounded'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import { ThemeContext } from '../../contexts/theme'
import { Meteors } from '@stianlarsen/meteors'
import './Navbar.css'

const NAV_LINKS = [
  { to: '/#home', label: 'Home' },
  { to: '/#story', label: 'Story' },
  { to: '/#skills', label: 'Skills' },
  { to: '/projects', label: 'Projects' },
  { to: '/blogs', label: 'Blogs' },
  { to: '/#contact', label: 'Contact' },
]

const Navbar = () => {
  const [{ themeName, toggleTheme }] = useContext(ThemeContext)
  const [showNavList, setShowNavList] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const toggleNavList = () => setShowNavList((open) => !open)
  const closeNavList = () => setShowNavList(false)

  useEffect(() => {
    document.body.style.overflow = showNavList ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [showNavList])

  useEffect(() => {
    closeNavList()
  }, [location.pathname, location.hash])

  const handleNav = async (e, to) => {
    e.preventDefault()
    closeNavList()

    const targetPathname = to.split('#')[0] || '/'
    const isSamePageSectionNav =
      location.pathname === targetPathname && to.includes('#')

    const rt = window.__routeTransition
    if (!isSamePageSectionNav && rt && typeof rt.play === 'function') {
      await rt.play()
    }

    navigate(to)

    if (!isSamePageSectionNav && rt && typeof rt.clear === 'function') {
      window.setTimeout(() => rt.clear(), 120)
    }
  }

  const navList = (
    <ul className="nav__list">
      <Meteors
        speed={0.1}
        size={20}
        amount={2}
        colorLightmode="#2978b5"
        colorDarkmode="white"
        fallingSide="left"
      />
      {NAV_LINKS.map(({ to, label }) => (
        <li key={to} className="nav__list-item">
          <Link to={to} onClick={(e) => handleNav(e, to)} className="link link--nav">
            {label}
          </Link>
        </li>
      ))}
    </ul>
  )

  const mobileChrome =
    typeof document !== 'undefined' &&
    createPortal(
      <div className={`nav-mobile-chrome ${themeName}`}>
        <button
          type="button"
          onClick={toggleNavList}
          className="btn btn--icon nav__hamburger"
          aria-label="toggle navigation"
          aria-expanded={showNavList}
          id="sortmenu"
        >
          {showNavList ? <CloseIcon /> : <MenuIcon />}
        </button>

        {showNavList && (
          <div className="nav-mobile-overlay" role="dialog" aria-modal="true">
            <button
              type="button"
              className="nav__backdrop"
              aria-label="Close navigation menu"
              onClick={closeNavList}
            />
            <div className="nav__panel">
              <div className="nav__panel-card">
                <Meteors
                  speed={0.1}
                  size={20}
                  amount={2}
                  colorLightmode="#2978b5"
                  colorDarkmode="white"
                  fallingSide="left"
                />
                <p className="nav__panel-label">Navigate</p>
                <ul className="nav__list nav__list--mobile">
                  {NAV_LINKS.map(({ to, label }) => (
                    <li key={to} className="nav__list-item">
                      <Link
                        to={to}
                        onClick={(e) => handleNav(e, to)}
                        className="link link--nav"
                      >
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>,
      document.body
    )

  return (
    <>
      <nav className="center nav">{navList}</nav>

      <button
        type="button"
        onClick={toggleTheme}
        className="btn btn--icon nav__theme"
        aria-label="toggle theme"
      >
        {themeName === 'dark' ? <WbSunnyRoundedIcon /> : <Brightness2Icon />}
      </button>

      {mobileChrome}
    </>
  )
}

export default Navbar
